import React, { useEffect, useState } from 'react'
import style from './SelectMyEmployee.module.scss'
import CardEmployeeSmall from '../CardEmployeeSmall/CardEmployeeSmall'
import {
  useCreateUserEmployeesMutation,
  useDeleteUserEmployeeMutation,
  useGetEmployeesQuery
} from '../../starter/api/employeesApi'
import { useAppSelector } from '../../starter/hooks/redux'
import { IEmployee } from '../../starter/model/interfaces'
import { useDrop } from 'react-dnd'

const SelectMyEmployee = () => {
  const { data: allEmployees } = useGetEmployeesQuery()
  const { employees: myEmployees } = useAppSelector((state) => state.employees)
  const [createUserEmployee] = useCreateUserEmployeesMutation()
  const [deleteUserEmployee] = useDeleteUserEmployeeMutation()

  const [filteredAllEmployee, setFilteredAllEmployee] = useState<IEmployee[]>(allEmployees || [])

  useEffect(() => {
    if (allEmployees && allEmployees.length) {
      setFilteredAllEmployee(
        allEmployees.filter((employee) => !myEmployees.map((empl) => empl._id).includes(employee._id))
      )
    }
  }, [allEmployees, myEmployees])

  const [{ isActive: isActiveEmployeeAddDrop }, dropAddRef] = useDrop({
    accept: 'employee-small',
    drop(item: IEmployee) {
      if (!myEmployees.map((e) => e._id).includes(item._id)) {
        createUserEmployee(item._id)
      }
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver()
    })
  })

  const [{ isActive: isActiveEmployeeRemoveDrop }, dropRemoveRef] = useDrop({
    accept: 'employee-small',
    drop(item: IEmployee) {
      if (myEmployees.map((e) => e._id).includes(item._id)) {
        deleteUserEmployee(item._id)
      }
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver()
    })
  })
  return (
    <div className={style.wrapper}>
      <div className={style.titles}>
        <div className={style.title}>Мои сотрудники</div>
        <div className={style.title}>Все сотрудники</div>
      </div>
      <div className={style.areas}>
        <div className={[style.areaWrapper, isActiveEmployeeAddDrop ? style.isActive : ''].join(' ')} ref={dropAddRef}>
          <div className={[style.areaItem].join(' ')}>
            {myEmployees.map((employee) => (
              <CardEmployeeSmall key={employee._id} employee={employee} isFree={false} />
            ))}
          </div>
        </div>

        <div
          className={[style.areaWrapper, isActiveEmployeeRemoveDrop ? style.isActive : ''].join(' ')}
          ref={dropRemoveRef}>
          <div className={[style.areaItem].join(' ')}>
            {filteredAllEmployee.map((employee) => (
              <CardEmployeeSmall key={employee._id} employee={employee} isFree={false} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
export default SelectMyEmployee
